import type {SelectOptionItem} from '@common/types';
import {useTranslation} from '#imports';
import type {TranslationKey} from '#build/i18n';

export function timeout(count: number) {
    return new Promise((resolve) => setTimeout(resolve, count));
}

export function insertIf<T extends any[]>(condition: boolean, ...elements: T): T | never[] {
    return condition ? elements : [];
}

type SlicePrefix<T extends string, S extends string> = S extends `${T}.${infer U}` ? U : never;

export function useMapEnumToOption<P extends string, T extends Record<string, SlicePrefix<P, TranslationKey>>>(
    prefix: (`${P}.${SlicePrefix<P, TranslationKey>}` extends TranslationKey ? true : false) extends true ? P : never,
    obj: T,
    pick?: T[keyof T][],
): SelectOptionItem[] {
    const {t} = useTranslation();
    return Object.entries(obj)
        .filter(([_, value]) => {
            if (pick) {
                return pick.includes(value as T[keyof T]);
            }
            return true;
        })
        .map(([_, value]) => ({name: t(`${prefix}.${value}` as any), id: value})); // Use value for id
}
